// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { goBack } from 'react-router-redux'
import { error, warning } from 'react-notification-system-redux'
import { initialize } from 'redux-form'
import { UNCAUGHT_ERROR } from 'errors'
import { loadingToggler } from 'redux/modules/loading'
import { AFS_PARAMETERS } from 'redux/modules/interferenceAnalysis/constants'
import { parseInterferenceParameters } from 'redux/modules/interferenceAnalysis/helpers'
import { fetchProjectInterferenceParameters } from 'helpers/api'
import sortParameterValuesByBand from './sortParameterValuesByBand'

import {
  loadAnalysisSettings,
  setParametersStatuses,
} from 'redux/modules/interferenceAnalysis'

const initializeParameters = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      await dispatch(loadAnalysisSettings())

      const {
        interferenceAnalysis,
        projectSummary,
      } = getState()

      const projectId = projectSummary.get('projectId')
      const unitType = projectSummary.get('unitType')

      const propagationModels = interferenceAnalysis.get('propagationModels')

      const doesProjectHavePathWithBand = projectSummary.get('paths').some(d => d.get('band'))

      if (!doesProjectHavePathWithBand) {
        const message = 'This project is not yet ready for analysis. No paths were found with bands.'
        dispatch(warning({ message }))

        // send them back one in router history.`
        dispatch(goBack())

        throw new Error(message)
      }

      try {
        // we get the parameter values from the API and prep them for redux-form.
        const { entities } = await fetchProjectInterferenceParameters(projectId)

        if (entities === null || entities.length === 0) {
          throw new Error('The application returned no Analysis Parameters. Please ensure your paths are ready for Analysis. If this issue persists, please contact support.')
        }

        const initialParameterValues = parseInterferenceParameters(entities, unitType, propagationModels)
        const sortedInitialParameterValues = dispatch(sortParameterValuesByBand(initialParameterValues))

        // then we take the initial parameter values and add statuses
        // for each band in this project. The statuses come from a different
        // API end point and are added the initial values object that we
        // pass to AFS_PARAMETERS below
        // these values won't change until the next time we initialize the form
        // but their UI components will update their own state if a status is
        // incomplete and we need to display a counter
        const bands = await dispatch(setParametersStatuses(sortedInitialParameterValues))

        dispatch(
          initialize(
            AFS_PARAMETERS,
            { bands },
          )
        )
      } catch (err) {
        console.warn(err)
        dispatch(error({
          autoDismiss: 0,
          message: err.message || UNCAUGHT_ERROR,
          title: 'Error initializing AFS Parameters',
        }))
        // throw this so that the caller doesn't try to
        // render the parameters page.
        throw dispatch(goBack())
      }
    })
  )
)

export default initializeParameters
